import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import {
  changeModalVisibility,
  setDoctorsList,
  setDoctorDataToEdit,
  setDoctorsCount,
} from '../../store/doctorsSlice';
import './DoctorsPage.scss';
import Button from '../../components/BaseComponents/Button';
import DoctorsModal from '../../components/Doctors/DoctorsModal';
import DoctorsTable from '../../components/Doctors/DoctorsTable';
import { getDoctorsList } from '../../api/doctors';
import { getDoctorsCount } from '../../api/counters';
import Loader from '../../components/BaseComponents/Loader';
import { UserRoleEnum } from '../../types/apiGeneratedTypes';
import { useNavigate } from 'react-router';

const Doctors: React.FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState<boolean>(true);
  const [error, setError] = React.useState<any>(null);
  const { doctorsCount, isAddDoctorModalOpened, limit } = useSelector(
    (state: RootState) => state.doctors
  );
  const {
    admin: { role },
  } = useSelector((state: RootState) => state.admin);
  const doctorsCountRef = useRef(doctorsCount);
  doctorsCountRef.current = doctorsCount;

  useEffect(() => {
    if (role === UserRoleEnum.Doctor || role === UserRoleEnum.Nutritionist) {
      navigate('/members');
    }
  }, [role, navigate]);

  useEffect(() => {
    const fetchDoctors = async () => {
      try {
        setLoading(true);
        const doctorsList = await getDoctorsList(0, limit);
        dispatch(setDoctorsList(doctorsList.doctors));
        if (!doctorsCountRef.current) {
          const doctorsCountResp = await getDoctorsCount();
          dispatch(setDoctorsCount(doctorsCountResp.total_count));
        }
      } catch (error) {
        setError(error);
      } finally {
        setLoading(false);
      }
    };

    fetchDoctors();
  }, [dispatch, limit]);

  const onAddClinicBtnClick = () => {
    dispatch(setDoctorDataToEdit(null));
    dispatch(changeModalVisibility(true));
  };
  const onModalClose = () => {
    dispatch(changeModalVisibility(false));
  };

  if (loading) return <Loader />;
  if (error) return <div>Error loading doctors list...</div>;

  return (
    <div className='page-container'>
      <div className='search-row-container sideBarPad'>
        <div className='search-and-filter-container'>
          {doctorsCount && (
            <div className='count-container'>
              {doctorsCount} {doctorsCount === 1 ? 'Doctor' : 'Doctors'}
            </div>
          )}
        </div>
        <Button
          isSecondary={true}
          text='Add Doctor'
          onClick={onAddClinicBtnClick}
        />
      </div>
      <DoctorsTable key={doctorsCount} />
      <DoctorsModal isOpen={isAddDoctorModalOpened} onClose={onModalClose} />
    </div>
  );
};
export default Doctors;
